/**
 * Provenance marker placed on a history entry's `state` by app-driven query-param
 * writes (filters, pagination, sort, columns). The persistence effect reads it to
 * tell an in-app write (persist to the bag) from an external URL change — a shared
 * link, an address-bar paste, or browser back/forward — which must NOT overwrite
 * the user's saved filters.
 *
 * Carrying provenance on the navigation (rather than a module-level latch) binds
 * it to the specific URL change: an app write that resolves to the same URL never
 * leaks an authorization forward to a later external change.
 */
export const APP_QUERY_WRITE_STATE = { panoramaQueryWrite: true } as const;

/** Narrows an unknown `location.state` to an app-driven query-param write. */
export const isAppQueryWriteNavigation = (
  state: unknown
): state is { panoramaQueryWrite: true } =>
  typeof state === 'object' &&
  state !== null &&
  Object.hasOwn(state, 'panoramaQueryWrite') &&
  (state as { panoramaQueryWrite?: unknown }).panoramaQueryWrite === true;
